import React from 'react'
import classNames from 'classnames'
import { Button } from '@/atoms/Button'
import { Image } from '@/atoms/Image'
import { LabelSM } from '@/atoms/Text'
import { SELECTED_SEAT } from '@/views/TicketCheckoutViews/SeatMapView/components/useAvailableSeatTypes'

interface SeatLegendButtonProps {
  onClick: () => void
  label: string
  showIcon?: boolean
  className?: string
}

const SeatLegendButton = ({ onClick, label, showIcon = true, className }: SeatLegendButtonProps) => {
  return (
    <Button
      onClick={onClick}
      className={classNames('flex items-center gap-2 bg-core-gray-900', className)}
      variant="core-gray-800"
    >
      {showIcon && <Image alt="seat icon" src={SELECTED_SEAT.cloudinaryPath} width={14} height={14} />}
      <LabelSM className="text-xs">{label}</LabelSM>
    </Button>
  )
}

export default SeatLegendButton
